<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="type=='edit'?'编辑任务文件':'添加任务文件'"
        width="1000px"
        append-to-body
        top="5vh"
        class="dialog-body-border-bottom modal-body-padding-bottom-10"
        :before-close="handleClose">
        <div class="content-wrap pb20">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="150px" v-loading="formLoading">
                <el-form-item label="媒体：" prop="plat_id">
                    <el-radio-group v-model="formItem.plat_id" :disabled="taskType=='edit'&&type=='edit'" @change="changePlat">
                        <!--<el-radio-button v-if="allowedPlatIds.includes('1')" label="1">OPPO</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('3')" label="3">vivo</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('4')" label="4">华为</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('10')" label="10">华为Ads</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('11')" label="11">荣耀</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('7')" label="7">小米</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('8')" label="8">爱奇艺</el-radio-button>-->
                        <el-radio-button v-if="allowedPlatIds.includes('9')" label="9">Apple</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="模板：" prop="template_id">
                    <el-select v-model="formItem.template_id" filterable placeholder="请选择模板" @visible-change="templateSelectVisibleChange" :loading="templateLoading" style="width:296px;">
                        <el-option
                            v-for="item in templateList"
                            :key="item.template_id"
                            :label="item.template_name"
                            :value="item.template_id">
                        </el-option>
                    </el-select>
                    <!--<el-button type="primary" size="mini" class="ml10 mr10" :disabled="!formItem.template_id" @click="previewTemp">预览</el-button>-->
                    <!--<el-button type="primary" size="mini" class="ml10 mr10" plain @click="toCreateTemp">创建模板</el-button>-->
                </el-form-item>
                <el-form-item label="账户&产品：" class="label-required mr50" prop="account_app">
                    <el-radio-group v-model="formItem.selectAPPType" @change="changeAppType">
                        <el-radio label="1">筛选产品
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px mb10" style="line-height: 1.5;">按照筛选的产品，统计该产品投放并且您有权限的账户广告数据，数据将按照模板展示。</p>
                                    <p class="font12px" style="line-height: 1.5;">筛选的产品投放了新的账户时，无需再次配置，若您有该账户的权限，则自动化报告生成时会自动携带。</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="2">筛选账户
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px">按照筛选的账户，统计所有数据，数据将模板展示。</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="3">筛选客户
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px mb10" style="line-height: 1.5;">按照筛选的客户，统计归属为该客户并且您有权限的账户数据，数据将按照模板展示。</p>
                                    <p class="font12px" style="line-height: 1.5;">筛选的客户绑定了新的账户时，无需再次配置，若您有该账户的权限，则自动化报告生成时会自动携带。</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="4" v-if="type=='edit'||pageFuncNames.includes('daily_task_account_app')">筛选账户+产品
                            <el-tooltip effect="dark" placement="top">
                                <span class="el-icon-question"></span>
                                <div slot="content" style="max-width: 325px;">
                                    <p class="font12px" style="line-height: 1.5;">按照筛选的账户与产品，统计这些产品在这些账户的数据，数据将按照模板展示。</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" class="mr50">
                    <div class="app-account-list app-list mt10" v-if="formItem.selectAPPType=='1'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">已选产品：{{formItem.app.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="appSelect"
                                            class="full-w remote-select-tags-width"
                                            collapse-tags
                                            v-model="formItem.app"
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="输入产品名称、ID、包名关键字搜索"
                                            :remote-method="remoteApp"
                                            :loading="appLoading">
                                            <el-option
                                                v-for="(item,index) in appList"
                                                :key="index"
                                                :label="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')"
                                                :value="item.subitem_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedApp.length<=0" class="tac text-color-gray">暂无数据</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedApp" :key="item.subitem_id+index" >
                                                <p class="relative ellipsis pr60" :title="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')">
                                                    {{item.subproject_name}}（{{item.subproject_id}}）<span v-if="formItem.plat_id=='3'">（{{item.subproject_content}}）</span>
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('app',item.subitem_id)" title="删除">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="app-account-list company-list mt10" v-if="formItem.selectAPPType=='2'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">已选账户：{{formItem.company.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="companySelect"
                                            class="full-w remote-select-tags-width"
                                            v-model="formItem.company"
                                            collapse-tags
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="输入账户名称、ID关键字搜索"
                                            :remote-method="remoteCompany"
                                            :loading="companyLoading">
                                            <el-option
                                                v-for="(item,index) in companyList"
                                                :key="item.account_id+index"
                                                :label="item.account_name+'（'+(formItem.plat_id=='3'?item.user_name:item.account_id)+'）'"
                                                :value="item.account_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedCompany.length<=0" class="tac text-color-gray">暂无数据</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedCompany" :key="item.account_id+index" >
                                                <p class="relative ellipsis pr40" :title="item.account_name+'（'+formItem.plat_id=='3'?item.user_name:item.account_id+'）'">
                                                    {{item.account_name}}（{{formItem.plat_id=='3'?item.user_name:item.account_id}}）
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('company',item.account_id)" title="删除">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="app-account-list customer-list mt10" v-if="formItem.selectAPPType=='3'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">已选客户：{{formItem.customer.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="customerSelect"
                                            class="full-w remote-select-tags-width"
                                            v-model="formItem.customer"
                                            collapse-tags
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="输入客户名称关键字搜索"
                                            :remote-method="remoteCustomer"
                                            :loading="customerLoading">
                                            <el-option
                                                v-for="(item,index) in customerList"
                                                :key="item.company_name+index"
                                                :label="item.company_name"
                                                :value="item.company_name">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedCustomer.length<=0" class="tac text-color-gray">暂无数据</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedCustomer" :key="item.company_name+index" >
                                                <p class="relative ellipsis pr40" :title="item.company_name">
                                                    {{item.company_name}}
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('customer',item.company_name)" title="删除">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="app-account-list mt10" v-if="formItem.selectAPPType=='4'">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">已选账户：{{formItem.company.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="companySelect"
                                            class="full-w remote-select-tags-width"
                                            @change="changeCompany"
                                            v-model="formItem.company"
                                            collapse-tags
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="输入账户名称、ID关键字搜索"
                                            :remote-method="remoteCompany"
                                            :loading="companyLoading">
                                            <el-option
                                                v-for="(item,index) in companyList"
                                                :key="item.account_id+index"
                                                :label="item.account_name+'（'+(formItem.plat_id=='3'?item.user_name:item.account_id)+'）'"
                                                :value="item.account_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedCompany.length<=0" class="tac text-color-gray">暂无数据</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedCompany" :key="item.account_id+index" >
                                                <p class="relative ellipsis pr40" :title="item.account_name+'（'+formItem.plat_id=='3'?item.user_name:item.account_id+'）'">
                                                    {{item.account_name}}（{{formItem.plat_id=='3'?item.user_name:item.account_id}}）
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('company',item.account_id)" title="删除">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="list-wrap">
                                    <h4 class="title-group">已选产品：{{formItem.app.length}}</h4>
                                    <div class="p10">
                                        <el-select
                                            ref="appSelect"
                                            class="full-w remote-select-tags-width"
                                            @change="changeApp"
                                            collapse-tags
                                            v-model="formItem.app"
                                            multiple
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="输入产品名称、ID、包名关键字搜索"
                                            :remote-method="remoteApp"
                                            :loading="appLoading">
                                            <el-option
                                                v-for="(item,index) in appList"
                                                :key="item.subitem_id+index"
                                                :label="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')"
                                                :value="item.subitem_id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checked-list">
                                        <p v-if="formCheckedApp.length<=0" class="tac text-color-gray">暂无数据</p>
                                        <ul>
                                            <li v-for="(item,index) in formCheckedApp" :key="item.subitem_id+index" >
                                                <p class="relative ellipsis pr60" :title="item.subproject_name+'（'+item.subproject_id+'）'+(formItem.plat_id=='3'?('（'+item.subproject_content+'）'):'')">
                                                    {{item.subproject_name}}（{{item.subproject_id}}）<span v-if="formItem.plat_id=='3'">（{{item.subproject_content}}）</span>
                                                    <span class="remove-btn text-color-error pointer absolute" @click="removeChecked('app',item.subitem_id)" title="删除">x</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <!-- 时区暂时隐藏掉 -->
                <el-form-item v-if="formItem.plat_id=='9'&&false" label="时区：" prop="time_zone" class="label-required">
                    <el-radio-group v-model="formItem.time_zone">
                        <el-radio label="Asia/Shanghai">上海</el-radio>
                        <el-radio label="UTC">UTC</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="文件名称：" prop="daily_file_name">
                    <el-input v-model.trim="formItem.daily_file_name" placeholder="请输入文件名称" style="width: 450px;"></el-input>
                    <el-checkbox v-model="formItem.file_date" true-label="1" false-label="0" class="ml10">+昨日日期</el-checkbox>
                </el-form-item>
                <el-form-item class="label-required"  prop="time_slot">
                    <div class="inline-block" slot="label">
                        <el-tooltip class="item" effect="dark" content="按照设置的统计周期生成相关日期的数据，不影响累计指标" placement="top-start">
                            <span><i class="el-icon-question pr4"></i>统计周期：</span>
                        </el-tooltip>
                    </div>
                    <el-radio-group v-model="formItem.statistical_period" @change="changeStatisticalPeriod">
                        <el-radio-button v-if="periodConfigNames.includes('last_7_days')" label="1">最近7天</el-radio-button>
                        <el-radio-button v-if="periodConfigNames.includes('last_30_days')" label="2">最近30天</el-radio-button>
                        <el-radio-button v-if="periodConfigNames.includes('all_days')" label="3">全部投放日期</el-radio-button>
                        <el-radio-button v-if="latestDaysConfig||is_super_admin" label="4" class="period-days">自定义最近天数</el-radio-button>
                        <el-radio-button v-if="startDateConfig||is_super_admin" label="5" class="period-date">自定义开始日期</el-radio-button>
                    </el-radio-group>
                    <div class="ml10 inline-block period-customize-the-latest-days" v-if="formItem.statistical_period=='4'&&(latestDaysConfig||is_super_admin)">
                        最近<el-input-number v-model="formItem.time_slot" label="天数" :disabled="!latestDaysConfig&&!is_super_admin" @change="changePeriodDays"  class="ml4 mr4"></el-input-number>天
                    </div>
                    <div class="ml10 inline-block period-customize-the-start-date" v-if="formItem.statistical_period=='5'&&(startDateConfig||is_super_admin)">
                        <el-date-picker
                            v-model="formItem.time_slot_date"
                            :picker-options="dateOptions"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :clearable="false"
                            :disabled="!startDateConfig&&!is_super_admin"
                            style="width: 160px;"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>

                    <div slot="error" slot-scope="scope" class="font12px text-color-error absolute" :style="{left:periodErrorLeft}">{{scope.error}}</div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac pt8">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">{{type=='add'?'添加':'保存'}}</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/efficiencyTool/task.js';
    import {platMap} from '@/constant/index.js';

    import * as dayjs from 'dayjs'
    export default {
        name: "TaskFileModal",
        props:{
            allowedPlatList:Array,
            data:Object,
            type:String,
            taskType:String,
            pageFuncNames:Array,
        },
        data(){
            let _this = this;
            const validateAccountApp = (rule,value,callback)=>{
                if(!_this.formItem.selectAPPType){
                    callback(new Error('请选择账户&产品'));
                }if(_this.formItem.selectAPPType=='1'&&_this.formItem.app.length<=0){
                    callback(new Error('请选择产品'));
                }else if(_this.formItem.selectAPPType=='2'&&_this.formItem.company.length<=0){
                    callback(new Error('请选择账户'));
                }else if(_this.formItem.selectAPPType=='3'&&_this.formItem.customer.length<=0){
                    callback(new Error('请选择客户'));
                }else if(_this.formItem.selectAPPType=='4'){
                    if(_this.formItem.company.length<=0&&_this.formItem.app.length<=0){
                        callback(new Error('请选择账户+产品'));
                    }else if(_this.formItem.company.length<=0){
                        callback(new Error('请选择账户'));
                    }else if(_this.formItem.app.length<=0){
                        callback(new Error('请选择产品'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            const validateTimeSlot = (rule,value,callback)=>{
                if(_this.formItem.statistical_period=='1'||_this.formItem.statistical_period=='2'||_this.formItem.statistical_period=='3'){
                    callback();
                }else if(_this.formItem.statistical_period=='4'){
                    if(!_this.formItem.time_slot){
                        callback(new Error('自定义最近天数：请设置天数'));
                    }else if(_this.formItem.time_slot<1){
                        callback(new Error('自定义最近天数：天数不能低于1天'));
                    }else if(+_this.formItem.time_slot%1!=0){
                        callback(new Error('自定义最近天数：天数必须设置成整数'));
                    }else if(!_this.latestDaysConfig){
                        callback();
                    }else if(_this.formItem.time_slot>_this.latestDaysConfig){
                        callback(new Error('自定义最近天数：最大可输入：'+_this.latestDaysConfig));
                    }else {
                        callback();
                    }
                }else if(_this.formItem.statistical_period=='5'){
                    if(!_this.formItem.time_slot_date){
                        callback(new Error('自定义开始日期：请选择开始日期'));
                    }else if(_this.startDateConfig&&(new Date(_this.formItem.time_slot_date)).getTime()-1000*60*60*24 < new Date(_this.startDateConfig).getTime()){
                        callback(new Error('自定义开始日期：只可选'+_this.startDateConfig+'之后的日期为开始日期'));
                    }else {
                        callback();
                    }
                }else{
                    callback(new Error('请设置统计周期'));
                }
            };
            const validateFileName = (rule,value,callback)=>{
                let reg = /[\[\]/\\*:?"<>|']/img;
                if(reg.test(value)){
                    callback(new Error('自定义文件名含有非法字符：/\\*:?"<>|[]'));
                }else{
                    callback();
                }
            };
            return {
                dialogVisible:false,
                formLoading:false,
                formItem:{
                    plat_id:'',
                    plat_name:'',
                    template_id:'',
                    selectAPPType:'',
                    daily_file_name:'',
                    statistical_period:'',
                    time_slot:undefined,
                    app:[],
                    company:[],
                    customer:[],
                    time_slot_date:'',
                    file_date:'',
                    time_zone:'Asia/Shanghai',
                },
                rules:{
                    plat_id:[
                        { required: true, message: '请选择媒体', trigger: 'blur' },
                    ],
                    template_id:[
                        { required: true, message: '请选择模板', trigger: 'blur' },
                    ],
                    account_app:[
                        { validator:validateAccountApp ,trigger:'blur'},
                    ],
                    daily_file_name:[
                        { required: true, message: '请输入文件名称', trigger: 'blur' },
                        { max: 100, message: '文件名不能超过100个字', trigger: 'blur' },
                        {pattern: /[^\[\]/\\*:?"<>|']+/g, message: '自定义文件名含有非法字符：/\\*:?"<>|[]',trigger: 'blur' },
                        { validator:validateFileName ,trigger:'blur'},
                    ],
                    time_slot:[
                        { validator:validateTimeSlot ,trigger:'blur'}
                    ],
                },
                templateLoading:false,
                templateList:[],
                appList:[],
                companyList:[],
                customerList:[],
                appLoading:false,
                companyLoading:false,
                customerLoading:false,
                dateOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        // if(_this.startDateConfig&&time.getTime() < new Date(_this.startDateConfig).getTime()){
                        //     return true;
                        // }else{
                        //     return time.getTime() > Date.now()-1000*60*60*24;
                        // }
                        return time.getTime() > Date.now()-1000*60*60*24;
                    },
                    cellClassName(time){
                        if(_this.startDateConfig&&time.getTime() < new Date(_this.startDateConfig).getTime()){
                            return '';
                        }else if(time.getTime() > Date.now()-1000*60*60*24){
                            return 'td-file-disabled-date-after';
                        }else{
                            return '';
                        }
                    },
                },
                allAppList:[],
                allCompanyList:[],
                allCustomerList:[],
            };
        },
        computed:{
            ...mapGetters(['daily_task_period_config','is_super_admin']),
            allowedPlatIds(){
                let platList = this.allowedPlatList||[];
                return platList.map(item=>item.id);
            },
            platName(){
                let platItem = platMap.find(item=>item.id==this.formItem.plat_id)||{};
                return platItem.displayName||'';
            },
            formCheckedApp(){
                let appIdList = this.formItem.app||[];
                return appIdList.map(id=>{
                    return this.allAppList.find(item=>item.subitem_id==id)||{};
                })
            },
            formCheckedCompany(){
                let companyIdList = this.formItem.company||[];
                return companyIdList.map(id=>{
                    return this.allCompanyList.find(item=>item.account_id==id)||{};
                })
            },
            formCheckedCustomer(){
                let customerIdList = this.formItem.customer||[];
                return customerIdList.map(id=>{
                    return this.allCustomerList.find(item=>item.company_name==id)||{};
                })
            },
            periodConfig(){
                return this.daily_task_period_config||[];
            },
            periodConfigNames(){
                return this.periodConfig.map(item=>item.name).filter(item=>!!item);
            },
            startDateConfig(){
                const { customize_the_start_date } = this.data;
                function subtractDay(date) {
                    return dayjs(new Date(date)).subtract(1, 'day').format('YYYY-MM-DD')
                }
                if (customize_the_start_date) {
                    // return customize_the_start_date
                    return subtractDay(customize_the_start_date);
                }
                let actionItem = this.periodConfig.find(item=>item.name=='customize_the_start_date');
                return actionItem? actionItem.config? subtractDay(actionItem.config) :'':'';
            },
            latestDaysConfig(){
                const { customize_the_latest_days } = this.data
                if (customize_the_latest_days) {
                    return customize_the_latest_days
                }
                let actionItem = this.periodConfig.find(item=>item.name=='customize_the_latest_days');
                return actionItem?+actionItem.config||'':'';
            },
            periodErrorLeft(){
                return 'auto';
                if(this.formItem.statistical_period=='4'){
                    let $periodDays = document.querySelector('.period-customize-the-latest-days');
                    if($periodDays){
                        return ($periodDays.offsetLeft+10)+'px';
                    }else {
                        return 'auto';
                    }
                }else if(this.formItem.statistical_period=='5'){
                    let $periodDays = document.querySelector('.period-customize-the-start-date');
                    if($periodDays){
                        return ($periodDays.offsetLeft+10)+'px';
                    }else {
                        return 'auto';
                    }
                }else{
                    return 'auto';
                }
            }
        },
        mounted(){
            let _this = this;
            $('body').on('mouseover', '.td-file-disabled-date', function (e) {
                // let $target = $(e.target);
                // let tipStr = '暂无权限，'+_this.startDateConfig+'及之前日期';
                // $target.attr('title', tipStr);
            }).on('mouseover', '.td-file-disabled-date-after', function (e) {
                let $target = $(e.target);
                let tipStr = '当天以后的时间不可选择';
                $target.attr('title', tipStr);
            });
        },
        methods:{
            showModal(){
                this.dialogVisible = true;

                this.$nextTick(()=>{
                    if(this.type=='edit'){
                        this.setData();
                    }else{
                        this.formItem.plat_id = '9';
                        this.formItem.file_date = '1';
                        this.setDefaultStatisticalPeriod();
                    }
                    this.getTemplateList();
                });
            },
            setData(){
                let data = this.data||{};

                this.formItem.plat_id = data.plat_id;
                this.formItem.plat_name = data.plat_name;
                this.formItem.template_id = data.template_id;
                this.formItem.selectAPPType = data.selectAPPType;
                this.formItem.daily_file_name = data.daily_file_name;

                this.formItem.file_date = data.file_date;
                this.formItem.time_slot = data.time_slot?data.time_slot:undefined;
                this.formItem.time_zone = data.time_zone;
                this.formItem.statistical_period = data.statistical_period;
                this.formItem.time_slot_date = data.time_slot_date;
                this.formItem.app = (data.app||[]).map(item=>item.subitem_id);
                this.formItem.company = (data.company||[]).map(item=>item.account_id);
                this.formItem.customer = (data.customer||[]).map(item=>item.company_name);
                this.allAppList = data.app||[];
                this.allCompanyList = data.company||[];
                this.allCustomerList = data.customer||[];

                this.appList = [...this.allAppList];
                this.companyList = [...this.allCompanyList];
                this.customerList = [...this.allCustomerList];
            },
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formItem = {
                    plat_id:'',
                    template_id:'',
                    selectAPPType:'',
                    daily_file_name:'',
                    statistical_period:'',
                    time_slot:undefined,
                    time_zone:'Asia/Shanghai',
                    app:[],
                    company:[],
                    customer:[],
                    time_slot_date:'',
                    file_date:'',
                };
                this.appLoading = false;
                this.appList = [];
                this.companyLoading = false;
                this.companyList = [];
                this.customerLoading = false;
                this.customerList = [];
                this.$refs.form.clearValidate();
                this.allAppList = [];
                this.allCompanyList = [];
                this.allCustomerList = [];
                this.setDefaultStatisticalPeriod();
            },
            setDefaultStatisticalPeriod(){
                let firstKey = this.periodConfigNames[0];
                if(firstKey){
                    let dataMap = {
                        last_7_days:'1',
                        last_30_days:'2',
                        all_days:'3',
                        customize_the_latest_days:'4',
                        customize_the_start_date:'5',
                    };
                    this.formItem.statistical_period = dataMap[firstKey]||'';
                }
            },
            getTemplateList(){
                console.log('getTemplateList');
                this.templateList = [];
                this.templateLoading = true;
                API.getPlatTemplateList({
                    plat_id:this.formItem.plat_id,
                }).then(res=>{
                    this.templateList = res.data||[];
                    this.templateLoading = false;
                },err=>{
                    console.log('getTemplateList err',err);
                    this.templateList = [];
                    this.templateLoading = false;
                });
            },
            previewTemp(){
                let platId = this.formItem.plat_id;
                let templateId = this.formItem.template_id;
                let templateItem = this.templateList.find(item=>item.template_id==templateId)||{};
                console.log('previewTemp',platId,templateId);

                let $router= this.$router.resolve({
                    name:'daily_task',
                    query:{
                        platId:platId,
                        templateId:templateId,
                        templateName:templateItem.template_name,
                        pageType:'view_template',
                    },
                });
                window.open($router.href, '_blank');
            },
            toCreateTemp(){
                let platId = this.formItem.plat_id;
                console.log('toCreateTemp',platId);

                if(platId==8){
                    if(!this.pageFuncNames.includes('daily_task_create_template')){
                        return this.$message.error('无创建权限');
                    }
                }else{
                    if(!this.pageFuncNames.includes('daily_task_create_template_new')){
                        return this.$message.error('无创建权限');
                    }
                }

                let $router= this.$router.resolve({
                    name:'daily_task',
                    query:{
                        platId:platId,
                        pageType:'create_template',
                    },
                });
                window.open($router.href, '_blank');
            },
            changePlat(val){
                console.log('changePlat',val);
                // this.getTemplateList();
                this.formItem.template_id = '';

                this.selectAPPType = '';
                this.appLoading = false;
                this.appList = [];
                this.formItem.app = [];
                this.companyLoading = false;
                this.companyList = [];
                this.formItem.company = [];
                this.customerLoading = false;
                this.customerList = [];
                this.formItem.customer = [];

                this.formItem.daily_file_name = '';
                this.formItem.file_date = '1';
                this.formItem.statistical_period = '1';
                this.formItem.time_slot_date = '';
                this.formItem.time_slot = undefined;
            },
            templateSelectVisibleChange(val){
                if(val){
                    this.getTemplateList();
                }
            },
            changeStatisticalPeriod(val){
                /* 3: 全部投放日期； 4：自定义天数； 5：自定义开始日期*/
                if(val=='4'){
                    this.formItem.time_slot = undefined;
                    this.$refs.form.clearValidate('time_slot');
                }else if(val=='5'){
                    this.formItem.time_slot = undefined;
                    this.formItem.time_slot_date = null;
                    this.$refs.form.clearValidate('time_slot');
                }else{
                    this.$refs.form.validateField('time_slot');
                }
            },
            changeAppType(){
                this.appLoading = false;
                this.appList = [];
                this.formItem.app = [];
                this.companyLoading = false;
                this.companyList = [];
                this.formItem.company = [];
                this.customerLoading = false;
                this.customerList = [];
                this.formItem.customer = [];
            },
            remoteCompany(query){
                if(!query){
                    return this.companyList = [];
                }
                this.companyLoading = true;
                let selectAPPType = this.formItem.selectAPPType;
                API.getAppCompanyList({
                    plat_id:this.formItem.plat_id,
                    search:query,
                    subitem_ids:selectAPPType=='4'?this.formItem.app:[],
                }).then(res => {
                    let resData = res.data || [];
                    this.companyLoading =  false;
                    this.companyList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allCompanyList.map(item=>item.account_id).includes(item.account_id)){
                            this.allCompanyList.push(item);
                        }
                    })
                },err=>{
                    this.companyLoading = false;
                    this.$message.error(err.info||'请求失败');
                    this.companyList = [];
                });
            },
            remoteCustomer(query){
                if(!query){
                    return this.customerList = [];
                }
                this.customerLoading = true;
                API.getCustomerList({
                    plat_id:this.formItem.plat_id,
                    search:query,
                }).then(res => {
                    let resData = res.data || [];
                    this.customerLoading =  false;
                    this.customerList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allCustomerList.map(item=>item.company_name).includes(item.company_name)){
                            this.allCustomerList.push(item);
                        }
                    })
                },err=>{
                    this.customerLoading = false;
                    this.$message.error(err.info||'请求失败');
                    this.customerList = [];
                });
            },
            remoteApp(query){
                if(!query){
                    return this.companyList = [];
                }
                this.appLoading = true;
                let selectAPPType = this.formItem.selectAPPType;
                API.getCompanyAppList({
                    plat_id:this.formItem.plat_id,
                    search:query,
                    account_ids:selectAPPType=='4'?this.formItem.company:[],
                }).then(res => {
                    let resData = res.data || [];
                    this.appLoading =  false;
                    this.appList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allAppList.map(item=>item.subitem_id).includes(item.subitem_id)){
                            this.allAppList.push(item);
                        }
                    })
                },err=>{
                    this.appLoading = false;
                    this.$message.error(err.info||'请求失败');
                    this.appList = [];
                });
            },
            changeCompany(){
                this.appList = [];
                this.getAppList();
            },
            changeApp(){
                this.companyList = [];
                this.getCompanyList();
            },
            getAppList(){
                if(this.formItem.company.length<=0){
                    return this.appList = [];
                }
                this.appLoading = true;
                API.getCompanyAppList({
                    plat_id:this.formItem.plat_id,
                    search:'',
                    account_ids:this.formItem.company,
                }).then(res => {
                    let resData = res.data || [];
                    this.appLoading =  false;
                    this.appList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allAppList.map(item=>item.subitem_id).includes(item.subitem_id)){
                            this.allAppList.push(item);
                        }
                    })
                },err=>{
                    this.appLoading = true;
                    this.$message.error(err.info||'请求失败');
                    this.appList = [];
                });
            },
            getCompanyList(){
                if(this.formItem.app.length<=0){
                    return this.companyList = [];
                }
                this.companyLoading = true;
                API.getAppCompanyList({
                    plat_id:this.formItem.plat_id,
                    search:'',
                    subitem_ids:this.formItem.app,
                }).then(res => {
                    let resData = res.data || [];
                    this.companyLoading =  false;
                    this.companyList = resData.slice(0,300);

                    resData.forEach(item=>{
                        if(!this.allCompanyList.map(item=>item.account_id).includes(item.account_id)){
                            this.allCompanyList.push(item);
                        }
                    })
                },err=>{
                    this.companyLoading = true;
                    this.$message.error(err.info||'请求失败');
                    this.companyList = [];
                });
            },
            removeChecked(type,id){
                console.log('removeChecked',type,id);
                let actionList = this.formItem[type];
                let index = actionList.findIndex(item=>item==id);
                if(index!=-1){
                    actionList.splice(index,1);
                }
                if(type=='app'&&this.formItem.selectAPPType=='1'){
                    /* 产品维度选账户，改变产品后，清空账户列表，重新更新账户列表 */
                    this.formItem.company = [];
                    this.getCompanyList();
                }
                if(type=='company'&&this.formItem.selectAPPType=='2'){
                    /* 账户维度选产品，改变账户后，清空产品列表，重新更新产品列表 */
                    this.formItem.app = [];
                    this.getAppList();
                }
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let data = {...this.formItem};
                        data.task_detail_id = this.data.task_detail_id;
                        data.plat_name = this.platName;
                        data.template_name = (this.templateList.find(item=>item.template_id==this.formItem.template_id)||{}).template_name||'';
                        data.app = data.app.map(item=>this.allAppList.find(inner=>inner.subitem_id==item)||{});
                        data.company = data.company.map(item=>this.allCompanyList.find(inner=>inner.account_id==item)||{});
                        data.customer = data.customer.map(item=>this.allCustomerList.find(inner=>inner.company_name==item)||{});
                        this.$emit('submit',this.type,{...data});
                        this.hideModal();
                    } else {
                        console.log('error submit!!');
                        this.$message.error('表单数据填写有误，请检查后重新提交');
                        return false;
                    }
                });
            },
            changePeriodDays(){
                this.$refs.form.validateField('time_slot');
            },
        }
    }
</script>

<style lang="scss" scoped>

    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }

    .app-account-list{
        .title-group{
            font-size: 12px;
            border-bottom: solid 1px #ccc;
            text-indent: 10px;
        }
        .list-wrap{
            border: solid 1px #ccc;

        }
        .checked-list{
            height: 200px;
            overflow-y: auto;
            padding: 10px;
            font-size: 12px;

            li{
                padding-left: 10px;
                p{
                    line-height: 24px;
                }
            }
            .remove-btn{
                right: 10px;
            }
        }

        .hide-tag ::v-deep  .el-select__tags .el-tag{
            display: none;
        }
    }

    .text-color-error{
        color: #F56C6C!important;
    }



</style>
